import { getGeneralLedgerData, getledgerbalance } from "./generalledger.js";

export function getStaffAccounts(context) { //20250213
    const {
        staff,
        currencies,
        exchangerates,
        basecurrency
    } = context;

    const generalledgerdata = getGeneralLedgerData(context);
    let filteredledgerdata = generalledgerdata
        .filter(data => data.accounttype == 'staff')

    const data = [];

    let currencysymbol = currencies.find(curr => curr.id == basecurrency)?.symbol

    staff.forEach((account) => {
        let accountledger = filteredledgerdata
            .filter(data => data.accountid == account.id)

        data.push({
            ...account,
            currencyid: basecurrency,
            currencysymbol: currencysymbol,
            balance: getledgerbalance(accountledger, exchangerates, basecurrency, 'staff'),
        });
    });

    data.sort((a, b) => {
        const nameComparison = a.name.localeCompare(b.name, 'en', { numeric: true });
        if (nameComparison === 0) {
            return parseFloat(a.balance) - parseFloat(b.balance);
        }
        return nameComparison;
    });

    return data;
}